import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  // Define categories and tools
  const categories = [
    {
      name: "JSON Tools",
      links: [
        { path: "/json-beautifier", label: "JSON Beautifier" },
        { path: "/json-escape-unescape", label: "JSON Escape/Unescape" },
        { path: "/json-compare", label: "JSON Compare" },
        { path: "/json-path-finder", label: "JSON Path Finder" }
      ]
    },
    {
      name: "Schema Tools",
      links: [
        { path: "/json-to-schema", label: "JSON to Schema" },
        { path: "/schema-validator", label: "Schema Validator" }
      ]
    },
    {
      name: "Encoders",
      links: [
        { path: "/base64-encoder", label: "Base64 Encoder" },
        { path: "/url-encoder", label: "URL Encoder" },
        { path: "/jwt-decoder", label: "JWT Decoder" },
        { path: "/hash-generator", label: "Hash Generator" }
      ]
    },
    {
      name: "Generators",
      links: [
        { path: "/uuid-generator", label: "UUID Generator" },
        { path: "/password-generator", label: "Password Generator" },
        { path: "/qr-code-generator", label: "QR Code Generator" },
        { path: "/lorem-ipsum", label: "Lorem Ipsum" }
      ]
    },
    {
      name: "Dev Utilities",
      links: [
        { path: "/http-status-checker", label: "HTTP Status Checker" },
        { path: "/regex-tester", label: "Regex Tester" },
        { path: "/text-diff-checker", label: "Text Diff Checker" },
        { path: "/text-replacer", label: "Text Replacer" }
      ]
    },
    {
      name: "Basic Tools",
      links: [
        { path: "/notepad", label: "Online Notepad" },
        { path: "/csharp-to-json", label: "C# to JSON" },
        { path: "/letter-count", label: "Letter Count" },
        { path: "/dummy-files", label: "Dummy Files" }
      ]
    },
    {
      name: "AI Tools",
      links: [
        { path: "/json-to-toon", label: "JSON to TOON" },
        { path: "/template-prompts", label: "Template Prompts" }
      ]
    }
  ];

  return (
    <footer className="footer-container">
      <div className="footer-content">
        <div className="footer-categories">
          {categories.map((category, index) => (
            <div key={index} className="footer-category">
              <h3 className="category-title">{category.name}</h3>
              <ul className="category-links">
                {category.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    <Link to={link.path}>{link.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        
        <div className="footer-info">
          <Link to="/" className="footer-home-link">Home</Link>
          <Link to="/sitemap" className="footer-home-link" style={{ marginLeft: '20px' }}>Sitemap</Link>
          <div className="footer-privacy">
            All operations are performed locally in your browser. Your data never leaves your computer.
          </div>
          <div className="footer-copyright">
            © {new Date().getFullYear()} JSON Tools. All rights reserved.
          </div>
        </div>
      </div>

      <style jsx>{`
        .footer-container {
          width: 100%;
          background: #f8f9fa;
          border-top: 1px solid #eaeaea;
          color: #666;
          font-size: 14px;
          margin-top: 40px;
          padding: 30px 0;
          box-sizing: border-box;
        }
        
        .footer-content {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 20px;
        }
        
        .footer-categories {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-around;
          gap: 30px;
          margin-bottom: 30px;
        }
        
        .footer-category {
          min-width: 160px;
        }
        
        .category-title {
          font-size: 16px;
          font-weight: 600;
          color: #444;
          margin: 0 0 15px 0;
          padding-bottom: 8px;
          border-bottom: 1px solid #eaeaea;
        }
        
        .category-links {
          list-style: none;
          padding: 0;
          margin: 0;
        }
        
        .category-links li {
          margin-bottom: 8px;
        }
        
        .category-links a {
          color: #666;
          text-decoration: none;
          transition: color 0.2s ease;
          font-size: 14px;
        }
        
        .category-links a:hover {
          color: #2196f3;
        }
        
        .footer-info {
          text-align: center;
          padding-top: 20px;
          border-top: 1px solid #eaeaea;
        }
        
        .footer-home-link {
          display: inline-block;
          color: #444;
          text-decoration: none;
          font-weight: 600;
          margin-bottom: 15px;
          font-size: 16px;
        }
        
        .footer-home-link:hover {
          color: #2196f3;
        }
        
        .footer-privacy {
          font-size: 13px;
          color: #888;
          margin-bottom: 10px;
          max-width: 600px;
          margin-left: auto;
          margin-right: auto;
        }
        
        .footer-copyright {
          font-size: 12px;
          color: #999;
        }
        
        @media (max-width: 768px) {
          .footer-categories {
            flex-direction: column;
            align-items: center;
            text-align: center;
            gap: 25px;
          }
          
          .footer-category {
            width: 100%;
            max-width: 250px;
          }
          
          .category-title {
            margin-bottom: 10px;
          }
          
          .footer-container {
            padding: 25px 0;
          }
        }
      `}</style>
    </footer>
  );
};

export default Footer; 